import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { METODOS_CALCULO } from "./dominios";
import { sanitizarAliquota } from "./aliquotaMetodo.util";

/** Mesmo .modal-grid / .span-2 / .modal-hint dos dois modais da Tabela NCM. */
const GRID = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: "16px 18px",
};
const SPAN_2 = { gridColumn: { xs: "auto", sm: "1 / -1" } };
const HINT = { fontSize: 12, color: "#888", marginTop: "6px", display: "block" };

/**
 * Alíquota interna (%) + Método de cálculo, usados no Novo Registro e no Editar. Bloco próprio
 * de linha inteira (grid interno de 2 colunas): assim os dois ficam sempre lado a lado, qualquer
 * que seja a posição em que o grid do modal parou.
 *
 * `bloqueado` + `motivoBloqueio`: linha global sem a permissão `ncm-table-edit-global` — os
 * campos continuam visíveis (o usuário vê o valor vigente) e o motivo aparece embaixo.
 */
export function CamposAliquotaMetodo({ aliquota, metodo, onChange, bloqueado, motivoBloqueio }) {
  return (
    <Box sx={SPAN_2}>
      <Box sx={GRID}>
        <TextField
          label="Alíquota interna (%)"
          placeholder="Ex.: 18,00"
          value={aliquota}
          // type="text" + inputMode="decimal": type="number" rejeita vírgula em boa parte dos
          // navegadores, e o usuário brasileiro digita "18,00".
          inputProps={{ inputMode: "decimal" }}
          onChange={(e) => onChange({ aliquota: sanitizarAliquota(e.target.value) })}
          disabled={bloqueado}
          fullWidth
          size="small"
        />
        <TextField
          select
          label="Método de cálculo"
          value={metodo}
          onChange={(e) => onChange({ metodo: e.target.value })}
          disabled={bloqueado}
          // displayEmpty + shrink: sem isso a opção "Herda do nível acima" (valor "") não aparece
          // no campo fechado e o rótulo fica por cima dela.
          SelectProps={{ displayEmpty: true }}
          InputLabelProps={{ shrink: true }}
          fullWidth
          size="small"
        >
          <MenuItem value="">Herda do nível acima</MenuItem>
          {METODOS_CALCULO.map((m) => (
            <MenuItem key={m.valor} value={m.valor}>
              {m.rotulo}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Typography component="span" sx={HINT}>
        {bloqueado && motivoBloqueio
          ? motivoBloqueio
          : "Em branco, alíquota e método herdam do nível acima."}
      </Typography>
    </Box>
  );
}
